import { Box, Button } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { animated as a, useSpring } from 'react-spring';
import { Link, navigate } from 'gatsby';
import { useForm } from 'react-hook-form';
import { useFormValue } from '../../../context';
import { usePlacesAutocomplete } from '../../../hooks/index';

const HeaderGetOffer = ({ showOffer }) => {
  const { formStore, setFormStore } = useFormValue();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: formStore,
    reValidateMode: 'onChange',
  });
  const styles = useSpring({
    width: '100%',
    left: '0px',
    opacity: showOffer ? 1 : 0,
    top: showOffer ? '0px' : '-200px',
  });
  const [selectedPrediction, setSelectedPrediction] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const predictions = usePlacesAutocomplete(searchValue);

  useEffect(() => {}, [searchValue]);

  useEffect(() => {
    setSearchValue(formStore.address);
    setValue('address', formStore.address);
  }, [formStore]);

  const handlePredictionSelection = (e, prediction) => {
    e.preventDefault();
    setSelectedPrediction(prediction);
    setValue('address', prediction.description);
    setSearchValue(prediction.description);
  };
  const onSubmit = (data) => {
    console.log('on submit ran', data);
    setFormStore((prev) => {
      return {
        ...prev,
        ...data,
      };
    });
    navigate('/get-offer/#get-offer-form');
  };

  return (
    <a.div style={styles}>
      <Box
        width="100%"
        zIndex="100"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            display={{ base: 'none', md: 'flex' }}
            flexDir={{ base: 'column', md: 'row' }}
            className="fixed-address-widget"
            justifyContent="center"
            alignItems="center"
          >
            <Box
              display={{ base: 'none', md: 'block' }}
              width={{ base: '100%', lg: '70%' }}
              position="relative"
            >
              <input
                type="address"
                id="address"
                defaultValue={formStore.address}
                autoComplete="off"
                placeholder="Put in your address to start your free offer"
                {...register('address', {
                  required: true,
                  maxLength: 80,
                })}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
              />
              {predictions.length
              && !selectedPrediction
              && !formStore.address ? (
                <Box
                  position="absolute"
                  transform="translateY(100%)"
                  backgroundColor="white"
                  rounded="lg"
                  bottom="0px"
                  borderColor="red.200"
                  width="100%"
                  p={2}
                  border="1px"
                >
                  {predictions?.map((prediction) => (
                    <Box
                      p={2}
                      key={prediction?.place_id}
                    >
                      <button
                        type="button"
                        onClick={(e) => handlePredictionSelection(e, prediction)}
                        onKeyDown={(e) => handlePredictionSelection(e, prediction)}
                      >
                        {prediction?.structured_formatting?.main_text
                          || 'Not found'}
                      </button>
                    </Box>
                  ))}
                  <img
                    src="https://developers.google.com/maps/documentation/images/powered_by_google_on_white.png"
                    alt="Powered by Google"
                  />
                </Box>
                ) : (
                  <div />
                )}
            </Box>
            <Box
              mx={2}
              mt={{ base: 2, md: 0 }}
            >
              <input
                className="light btn-one"
                type="submit"
                value="Get Offer"
              />
            </Box>
          </Box>
        </form>
        <Box
          display={{ base: 'flex', md: 'none' }}
          justifyContent="center"
        >
          <Link to="/get-offer/#get-offer-form">
            <Button
              size="sm"
              variant="btnTwo"
            >
              Get your offer
            </Button>
          </Link>
        </Box>
      </Box>
    </a.div>
  );
};

export default HeaderGetOffer;
